import { render, staticRenderFns } from "./userAuthority.vue?vue&type=template&id=728a85da&scoped=true&"
import script from "./userAuthority.vue?vue&type=script&lang=js&"
export * from "./userAuthority.vue?vue&type=script&lang=js&"
import style0 from "./userAuthority.vue?vue&type=style&index=0&id=728a85da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a85da",
  null
  
)

export default component.exports